import React from 'react';
import ReactDOM from 'react-dom';
//import reportWebVitals from './reportWebVitals';

//Components
import App from './components/App';

//Styles
//import './styles/index.css';

ReactDOM.render(
  <App />,
  document.getElementById('csftool-content')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
